import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ReserveHeader } from '../../components/Header';
import { Footer } from '../../components/Footer';
import { createDisplayDate } from '../../utils';
import { DEFAULT_HOME_USE_LABEL } from '../../constants';

const CancelComplete = function () {
  const location = useLocation();
  const state = location.state ?? '';

  const { lgCd = '', rsvNumber = '', rsvDate = '' } = state;

  const reserveChange = useSelector((state) => state.reserveChange);
  const rsvConfig = useSelector((state) => state.rsvConfig);
  const homeUseLabel = rsvConfig.locationSetting?.item_label?.home_use || DEFAULT_HOME_USE_LABEL;

  const { place = '', useHome = false } = reserveChange;
  const {
    name: placeName = '',
    address: placeAddress = '',
    subAddress: placeSubAddress = '',
    tel: placeTel = '',
  } = place;

  const displayRecItems = () => {
    const result = [];
    const { recItem: recItems, business } = reserveChange;

    const businessKeys = Object.keys(business);
    for (let i = 0; i < businessKeys.length; i += 1) {
      const nowBusinessKey = businessKeys[i];
      const { businessName = '' } = business[nowBusinessKey];
      const targetRecItems = recItems.filter((item) => parseInt(item.businessId, 10) === parseInt(nowBusinessKey, 10));

      const recItemKeys = Object.keys(targetRecItems);
      if (recItemKeys.length > 0) {
        result.push(<h3>{businessName}</h3>);
      }

      const tmpItems = {};
      for (let j = 0; j < recItemKeys.length; j += 1) {
        const nowRecItem = recItemKeys[j];
        const { groupId, groupName, recItemId, recItemName } = targetRecItems[nowRecItem];

        if (!tmpItems[groupId]) {
          tmpItems[groupId] = { groupName, items: [] };
        }

        tmpItems[groupId].items[recItemId] = <li style={{ marginLeft: '24px' }}>{recItemName}</li>;
      }

      const items = [];
      Object.keys(tmpItems).map((e) => {
        items.push(<strong>■{tmpItems[e].groupName}</strong>);
        items.push(<ul key={`item${i}`}>{tmpItems[e].items}</ul>);
      });

      result.push(items);
    }

    return result;
  };

  return (
    <>
      <ReserveHeader servCd="reserve" lgCd={lgCd} />
      <div id="container">
        <main>
          <article>
            <div id="contents">
              <div className="inner">
                <h2>キャンセル完了</h2>
                <p className="txtCenter mb40">予約のキャンセルを完了しました</p>
                <p className="txtCenter">
                  <strong style={{ fontSize: '20px' }}>キャンセル内容</strong>
                </p>
                <table className="tbl_confirmation noBorder mt0">
                  <tbody>
                    <tr>
                      <th>予約番号</th>
                      <td>{rsvNumber}</td>
                    </tr>
                    <tr>
                      <th>利用場所</th>
                      <td>
                        {useHome ? (
                          homeUseLabel
                        ) : (
                          <>
                            {placeName}
                            {placeName && placeAddress ? <br /> : null}
                            {`${placeAddress} ${placeSubAddress}`}
                            {placeAddress && placeTel ? <br /> : null}
                            {placeTel ? `TEL: ${placeTel}` : ''}
                          </>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>利用日時</th>
                      <td>{createDisplayDate(rsvDate, 'YYYY/MM/DD hh:mm')}</td>
                    </tr>
                    {displayRecItems().length === 0 ? null : (
                      <tr>
                        <th>用件</th>
                        <td>{displayRecItems()}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <p className="txtCenter">
                  予約をキャンセルしました。
                  <br />
                  ブラウザを閉じてください。
                </p>
              </div>
            </div>
          </article>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default CancelComplete;
